<div class="display-career-valuation-personal-summary">
    <div class="d-flex flex-column">
        <span class="career-valuation-total"
              data-test="career-valuation-total">
            <span>{{ actualTotal }}</span>%
        </span>

        <adapt-cvt-personal-differentials-chart [careerValuation]="careerValuation"></adapt-cvt-personal-differentials-chart>

        @if (careerValuation) {
            <table class="mt-3 table table-striped">
                <tbody>
                    @for (categoryValue of careerValuation.categoryValues; track categoryValue) {
                        <tr data-test="category-score-row">
                            <td>
                                <p>{{ categoryValue.category.name }}</p>
                            </td>
                            <td style="text-align: right">
                                <span>{{ categoryValue.extensions.score }}</span>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</div>
